module.exports = __webpack_public_path__ + "339233e471b772666625b377b42622f3.svg";